<div class="submit-actions" *ngIf="!disabled">
  <button class="btn primary-button" (click)="openAddRecordCaseModal()"><i class="bi bi-plus"></i>{{ 'label.add_case' | translate }}</button>
</div>

<app-dynamic-table
  [columns]="columns"
  [rows]="caseRecords"
  [dataTableMinWidth]="800"
  [useExternalApi]="problemRecordId ? true : false"
  [totalCount]="totalCount"
  [dataTableState]="caseRecordsDataTableState"
  (actionButtonEvent)="onActionButton($event)"
  (dataTableStateEvent)="getDataTableState($event)"
  (linkedValueClickEvent)="getLinkedValue($event)"
></app-dynamic-table>
